<template>
  <div class="wap-header">
    <div class="normal-wap-header" v-if="!submenu" :class="headerClasses">
      <div class="normal-wap-logo" @click="toHome">
        <img v-if="showBlackLogo" src="../assets/logo-t.png" alt="春阳台" />
        <img v-else src="../assets/logo-w.png" alt="春阳台" />
      </div>
      <div class="normal-wap-menu">
        <div class="open-menu" @click="openMenu">
          <img v-if="showBlackLogo" src="../assets/menu-wap-b.png" alt="菜单" />
          <img v-else src="../assets/menu-wap-w.png" alt="菜单" />
        </div>
      </div>
    </div>

    <div class="wap-sub-menu" :class="subMenuClasses" v-else>
      <div class="wap-sub-menu-top" :class="subMenuClasses">
        <div class="sub-wap-left">
          <div class="lan" :class="subMenuClasses">
            <div
              @click="changeLan(0)"
              class="changeLan"
              :class="{ lanActive: lan === 0 }"
            >
              中
            </div>
            <div
              @click="changeLan(1)"
              class="changeLan"
              :class="{ lanActive: lan === 1 }"
              v-show="shouldShowEnLan"
            >
              EN
            </div>
          </div>
          <!-- <div class="" :class="cultureClasses" @click="toCulture">
            <img
              v-if="columnShowId == 7"
              src="../assets/shop_highllight.png"
              alt="文化商店"
            />
            <img
              v-else-if="showBlackLogo"
              src="../assets/shop_black.png"
              alt="文化商店"
            />
            <img v-else src="../assets/shop_white.png" alt="文化商店" />
          </div> -->
        </div>
        <div class="sub-wap-menu-right">
          <div class="close-menu" @click="closeMenu">
            <img v-if="showBlackLogo" src="../assets/close.png" alt="关闭" />
            <img v-else src="../assets/close-w.png" alt="关闭" />
          </div>
        </div>
      </div>

      <div class="wap-line-first"></div>
      <div class="sub-wap-content">
        <div
          class="sub-wap-content-info"
          v-for="(item, index) in headerList"
          :key="item.id"
        >
          <div
            class="sub-wap-content-title"
            @click="selColumn(index)"
            :class="getTitleClasses(item)"
          >
            {{ isEnglish ? item.enName : item.name }}
          </div>

          <div v-if="item.subList.length > 1 && item.id == columnIndex">
            <div
              class="sub-wap-subtitle"
              :class="getSubtitleClasses(item, el)"
              v-for="el in filteredSubList(item)"
              :key="el.id"
            >
              <a v-if="el.toId && columnShowId == 1" @click="goToSmooth(el.id)">
                {{ isEnglish ? el.enName : el.name }}
              </a>
              <a v-else-if="el.id === 1 && el.requestTo === 'aboutCY'" @click="goToSameRoute(el.id)">
                {{ isEnglish ? el.enName : el.name }}
              </a>
              <router-link
                v-else
                :to="{ name: el.requestTo, query: { columnId: el.id } }"
              >
                {{ isEnglish ? el.enName : el.name }}
              </router-link>
            </div>
          </div>
          <div class="wap-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_COLUMN_ID = 38;
const SCROLL_COLUMNS = [
  1, 11, 13, 12, 2, 23, 21, 3, 31, 32, 33, 34, 35, 4, 41, 5, 51, 52, 53, 54,
  55, 6, 61, 62, 63, 64, 65, 7,
];
const COLUMN_MAP = {
  1: [1, 11, 12, 13],
  2: [2, 23, 21],
  3: [3, 31, 32, 33, 34, 35],
  4: [4, 41],
  5: [5, 52, 53, 54, 55],
  51: [51],
  6: [6, 61, 62, 63, 64, 65],
  7: [7],
};
const MENU_MAP = {
  1: [1, 11, 12, 13, 38],
  2: [2, 23, 21],
  3: [3, 31, 32, 33, 34, 35],
  4: [4, 41],
  5: [5, 51, 52, 53, 54, 55],
  6: [6, 61, 62, 63, 64, 65],
  7: [7],
};
const ELEMENT_MAP = {
  11: "keySpace",
  12: "architecture",
};

// 通用的路由跳转方法，处理重复导航错误
const safeNavigate = async (router, route) => {
  try {
    await router.push(route);
  } catch (err) {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  }
};

// 通用的路由替换方法，处理重复导航错误
const safeReplace = async (router, route) => {
  try {
    await router.replace(route);
  } catch (err) {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  }
};

export default {
  name: "WapHeader",
  props: {
    index: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isIndex: this.index,
      headerList: [
        // 关于春阳台
        {
          id: 1,
          name: "关于春阳台",
          enName: "About CYT",
          requestTo: "aboutCY",
          subList: [
            {
              id: 1,
              name: "春阳台概况",
              enName: "About CYT",
              requestTo: "aboutCY",
              toId: false,
            },
            {
              id: 11,
              name: "特色空间",
              enName: "Space",
              requestTo: "aboutCY",
              toId: true,
            },
            {
              id: 12,
              name: "关于建筑",
              enName: "Architecture",
              requestTo: "aboutCY",
              toId: true,
            },
          ],
        },
        // 展览
        {
          id: 2,
          name: "展览",
          enName: "Exhibitions",
          requestTo: "exhibition",
          subList: [
            {
              id: 2,
              name: "正在展出",
              enName: "On Now",
              requestTo: "exhibition",
              toId: false,
            },
            {
              id: 21,
              name: "过往展出",
              enName: "Past",
              requestTo: "previousExhibitions",
              toId: false,
            },
          ],
        },
        // 活动
        {
          id: 3,
          name: "活动",
          enName: "Events",
          requestTo: "activityList",
          subList: [
            {
              id: 3,
              name: "展览项目",
              enName: "Exhibition Events",
              requestTo: "activityList",
              toId: false,
            },
            {
              id: 31,
              name: "学术活动",
              enName: "Academic",
              requestTo: "scienceActive",
              toId: false,
            },
            {
              id: 32,
              name: "研学与公教活动",
              enName: "Research and Education",
              requestTo: "researchEducation",
              toId: false,
            },
            {
              id: 33,
              name: "公共活动",
              enName: "Public",
              requestTo: "publicActivities",
              toId: false,
            },
            {
              id: 34,
              name: "品牌活动",
              enName: "Brand",
              requestTo: "brandActivity",
              toId: false,
            },
          ],
        },
        // 研究
        {
          id: 4,
          name: "研究",
          enName: "Research",
          requestTo: "study",
          subList: [
            {
              id: 4,
              name: "春阳典藏",
              enName: "Research",
              requestTo: "study",
              toId: false,
            },
          ],
        },
         // 文创
        {
          id: 7,
          name: "文创",
          enName: "Culture-Themed Products",
          requestTo: "culturalCreative",
          subList: [
            {
              id: 7,
              name: "文创商店",
              enName: "Culture-Themed Products",
              requestTo: "culturalCreative",
              toId: false,
            },
          ],
        },
        // 塱头
        {
          id: 5,
          name: "塱头",
          enName: "About Langtou",
          requestTo: "rural",
          subList: [
            {
              id: 51,
              name: "项目大事记",
              enName: "Memorabilia",
              requestTo: "Memorabilia",
              toId: false,
            },
            {
              id: 5,
              name: "项目概况",
              enName: "Overview",
              requestTo: "rural",
              toId: false,
            },
            {
              id: 52,
              name: "古村展览",
              enName: "Exhibitions",
              requestTo: "currentExhibition",
              toId: false,
            },
            // AI-Generated Begin
            {
              id: 54,
              name: "国际驻留",
              enName: "Residency",
              requestTo: "educationCentre",
              toId: false,
            },
            // AI-Generated End
            {
              id: 53,
              name: "住宿体验",
              enName: "Guesthouse",
              requestTo: "lodgingExperience",
              toId: false,
            },
          ],
        },
        // 参观指南
        {
          id: 6,
          name: "发现更多",
          enName: "Discover More",
          requestTo: "visitor",
          subList: [
            {
              id: 61,
              name: "参观指南",
              enName: "Visitor Guide",
              requestTo: "visitor",
              toId: false,
            },
            {
              id: 62,
              name: "成为会员",
              enName: "Membership",
              requestTo: "Membership",
              toId: false,
            },
            {
              id: 63,
              name: "媒体中心",
              enName: "Press Releases",
              requestTo: "pressReleases",
              toId: false,
            },
            {
              id: 64,
              name: "数字资料",
              enName: "Digital Assets",
              requestTo: "digitalAssets",
              toId: false,
            },
          ],
        },
      ],
      lan: this.$store.state.isEn,
      isLoaded: this.$store.state.isLoaded,
      columnId: DEFAULT_COLUMN_ID,
      nowScrollToTop: 0,
      submenu: false,
      columnIndex: 0,
      columnShowId: 0,
      showScroll: false,
    };
  },

  computed: {
    isEnglish() {
      return this.lan === 1;
    },

    showBlackLogo() {
      return this.nowScrollToTop >= 19 || this.showScroll;
    },

    shouldShowEnLan() {
      // 始终显示英文语言选项
      return true;
    },

    headerClasses() {
      return {
        scroll: this.nowScrollToTop >= 19 || this.showScroll,
      };
    },

    subMenuClasses() {
      return {
        wapSubMenu: this.nowScrollToTop >= 19 || this.showScroll,
      };
    },

    cultureClasses() {
      return {
        wapCulture: this.nowScrollToTop >= 19 || this.showScroll,
        topCulture: !this.showScroll,
      };
    },
  },

  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },

    "$store.state.isLoaded"(newVal) {
      this.isLoaded = newVal;
    },
  },

  created() {
    this.initLanguage();
  },

  mounted() {
    this.initColumnId();
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    initLanguage() {
      let lan;
      const urlLan = this.$route.query.lan;

      // 语言映射表
      const langMap = { EN: 1, CN: 0 };

      if (urlLan !== undefined) {
        const normalized = String(urlLan).toUpperCase();
        lan = langMap.hasOwnProperty(normalized)
          ? langMap[normalized]
          : parseInt(normalized, 10) || 0;
      } else {
        try {
          lan = JSON.parse(localStorage.getItem("lan")) || 0;
        } catch (e) {
          console.error("本地语言解析失败:", e);
          lan = 0;
        }
      }

      this.lan = lan;
      this.$store.commit("changeLan1", this.lan);
    },

    initColumnId() {
      let columnId = this.$route.query.columnId;
      if (columnId === undefined) {
        columnId = DEFAULT_COLUMN_ID;
      }

      // 控制页面顶部是否展示为滚动效果
      this.showScroll = SCROLL_COLUMNS.includes(Number(columnId));

      // 控制头部页面类型选择
      for (const [showId, ids] of Object.entries(COLUMN_MAP)) {
        if (ids.includes(Number(columnId))) {
          this.columnShowId = Number(showId);
          break;
        }
      }

      // 处理滚动定位
      if ([11, 12].includes(Number(columnId))) {
        this.$nextTick(() => {
          if (columnId == 11) {
            const keySpaceElement = document.getElementById("keySpace");
            keySpaceElement?.scrollIntoView({ behavior: "smooth" });
          }
          if (columnId == 12) {
            const architectureElement = document.getElementById("architecture");
            architectureElement?.scrollIntoView({ behavior: "smooth" });
          }
        });
      }

      this.columnId = columnId;
    },

    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.nowScrollToTop = Math.floor(scrollTop);
    },

    filteredSubList(item) {
      // 显示所有菜单项，包括大事记
      return item.subList;
    },

    getTitleClasses(item) {
      return {
        wapSubMenu: this.nowScrollToTop >= 19 || this.showScroll,
        redUn: item.subList.length <= 1 && item.id == this.columnId,
      };
    },

    getSubtitleClasses(item, el) {
      return {
        wapSubMenu: this.nowScrollToTop >= 19 || this.showScroll,
        lineUn: item.subList.length > 1 && el.id == this.columnId,
      };
    },

    changeLan(lang) {
      if (this.lan === lang) return;

      this.$store.commit("changeLan");
      this.lan = this.$store.state.isEn;
      localStorage.setItem("lan", this.lan);

      // 在详情页切换语言时返回上一级页面
      if (this.$route.matched[1]?.meta.title === "detail") {
        let id;
        try {
          id = JSON.parse(localStorage.getItem("columnId"));
        } catch (e) {
          console.log(e);
        }

        this.$router.push({
          path: this.$route.matched[0].path,
          query: { columnId: id },
        });
      }
    },

    openMenu() {
      const columnId = this.$route.query.columnId || DEFAULT_COLUMN_ID;
      this.columnId = columnId;

      // 控制头部页面类型选择
      for (const [index, ids] of Object.entries(MENU_MAP)) {
        if (ids.includes(Number(columnId))) {
          this.columnIndex = Number(index);
          break;
        }
      }

      this.submenu = !this.submenu;
    },

    selColumn(index) {
      const item = this.headerList[index];

      if (item.subList.length === 1) {
        safeNavigate(this.$router, {
          name: item.subList[0].requestTo,
          query: { columnId: item.subList[0].id },
        });
        this.submenu = false; // 跳转后关闭菜单
        return;
      }

      // 对于多子菜单项，切换展开状态
      const menuIndex = item.id; // 使用item.id而不是index+1
      this.submenu = true; // 保持菜单打开
      this.columnIndex = this.columnIndex === menuIndex ? 0 : menuIndex; // 切换当前选中项
    },

    async goToSameRoute(id) {
      this.submenu = false;
      
      // 对于春阳台概况（id=1），滚动到顶部锚点
      if (id === 1) {
        const element = document.getElementById("aboutCYTop");
        element?.scrollIntoView({ behavior: "smooth" });
        // 更新URL但不刷新页面
        await safeReplace(this.$router, {
          name: 'aboutCY',
          query: { columnId: id }
        });
        return;
      }
      
      // 对于其他锚点，使用goToSmooth方法
      this.goToSmooth(id);
    },

    closeMenu() {
      this.submenu = false;
    },

    toCulture() {
      safeNavigate(this.$router, {
        name: "culturalCreative",
        query: { columnId: 7 },
      });
    },

    toHome() {
      window.scrollTo(0, 0);
      safeNavigate(this.$router, {
        name: "Home",
        query: { columnId: DEFAULT_COLUMN_ID },
      });
    },

    async goToSmooth(id) {
      this.submenu = false;

      const elementId = ELEMENT_MAP[id];
      if (elementId) {
        const element = document.getElementById(elementId);
        element?.scrollIntoView({ behavior: "smooth" });
        
        // 更新URL但不刷新页面
        await safeReplace(this.$router, {
          name: 'aboutCY',
          query: { columnId: id }
        });
      }
    },
  },
};
</script>

<style scoped>
.normal-wap-header {
  min-width: 365px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
}
.normal-wap-logo {
  float: left;
  line-height: 80px;
  max-width: 227px;
  margin-left: 40px;
}
.normal-wap-logo img {
  width: 224px;
  height: 40px;
}
.normal-wap-header .normal-wap-menu {
  position: relative;
  top: 0px;
  right: 3%;
  height: 25px;
  width: 40px;
  z-index: 1000;
}
.sub-wap-menu-right {
  position: relative;
  top: 0px;
  right: 5%;
  height: 80px;
  line-height: 80px;
  width: 25px;
  z-index: 1000;
}
.open-menu {
  display: block;
  width: 25px;
  height: 25px;
  position: relative;
  cursor: pointer;
  object-fit: contain;
}

.wap-sub-menu {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  margin-top: 1px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #000;
}

.wap-sub-menu-top {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  background-color: #000;
  justify-content: space-between;
}
.sub-wap-left {
  display: flex;
  margin-left: 10px;
}
.lan {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 80px;
  line-height: 80px;
  font-family: SourceHanSansCN-Bold;
  font-size: 15px;
  margin-left: 20px;
  color: #fff;
  text-align: left;
}
.changeLan {
  width: 50px;
  height: 100%;
  text-align: center;
  font-weight: normal;
}
.lanActive {
  color: #ca9d76;
  font-weight: normal;
}
.topCulture {
  position: relative;
  float: right;
  z-index: 100;
  width: 14px;
  height: 80px;
  line-height: 80px;
  margin-left: 25px;
  cursor: pointer;
}
.wapCulture {
  position: relative;
  float: right;
  z-index: 100;
  width: 14px;
  height: 80px;
  line-height: 80px;
  margin-left: 25px;
  cursor: pointer;
}
.topCulture::after {
  content: "";
  position: absolute;
  left: -12px;
  top: 100%;
  transform: translateY(-300%);
  width: 1px;
  height: 15px;
  background-color: #fff;
}
.topCulture::before {
  content: "";
  position: absolute;
  right: -12px;
  top: 100%;
  transform: translateY(-300%);
  width: 1px;
  height: 15px;
  background-color: #fff;
}
/* .wapCulture::after {
  content: "";
  position: absolute;
  left: -12px;
  top: 100%;
  transform: translateY(-300%);
  width: 1px;
  height: 15px;
  background-color: #000;
}
.wapCulture::before {
  content: "";
  position: absolute;
  right: -12px;
  top: 100%;
  transform: translateY(-300%);
  width: 1px;
  height: 15px;
  background-color: #000;
} */
.close-menu img {
  width: 22px;
  height: 22px;
}
.wap-line-first {
  margin: 80px auto 0;
  width: 90%;
  z-index: 100;
  height: 1px;
  background-color: #585c64;
}
.wap-line {
  margin: 0 auto;
  width: 90%;
  height: 1px;
  background-color: #585c64;
}
.sub-wap-content {
  margin-top: 0px; /* 确保内容不会覆盖顶部菜单 */
  max-height: calc(100vh - 100px); /* 视口高度减去顶部菜单的高度 */
  overflow-y: auto; /* 允许垂直滚动 */
  -webkit-overflow-scrolling: touch; /* 改善移动设备上的滚动体验 */
}
.sub-wap-content-title {
  width: 90%;
  position: relative;
  height: 100px;
  font-family: SourceHanSansCN-Bold;
  font-size: 22px;
  color: #ffffff;
  text-align: left;
  font-weight: 700;
  line-height: 110px;
  margin: 0 auto;
}
.sub-wap-subtitle {
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: left;
  font-weight: 500;
  width: 80%;
  margin: 0px 0 10px 60px;
}
.sub-wap-subtitle a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #fff;
  height: 30px;
  padding-bottom: 2px;
  overflow: hidden;
  background-image: linear-gradient(
    to right,
    #2c2c2c 100%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: 0% 100%;
  background-repeat: no-repeat;
  background-size: 0 2px;
  transition: background-size 0.3s;
}
.sub-wap-subtitle:last-child {
  margin-bottom: 30px;
}
/* 屏幕滚动后的处理 */
.scroll {
  height: 80px;
  background-color: #fff; /* 替换为你需要的颜色 */
  border-bottom: 1px solid #f2f2f2;
  z-index: 1000;
}
.wapSubMenu {
  color: #000;
  background-color: #fff; /* 替换为你需要的颜色 */
}
.wapSubMenu a {
  color: #000;
}
.redUn {
  color: #ca9d76;
}

.lineUn a {
  color: #ca9d76;
  height: 32px;
}
.lineUn a::after {
  content: "";
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 2px;
  z-index: 999;
  background-color: #ca9d76;
}
@media (max-width: 450px) {
  .normal-wap-logo {
    float: left;
    max-width: 176px;
    margin-left: 20px;
  }
  .normal-wap-logo img {
    float: left;
    max-width: 176px;
    height: 32px;
  }
  .normal-wap-header .normal-wap-menu {
    position: relative;
    top: 0px;
    right: 10px;
    height: 25px;
    width: 30px;
    z-index: 1000;
  }
  .wap-sub-menu-top {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 80px;
    display: flex;
    background-color: #000;
    justify-content: space-between;
  }
  .sub-wap-left {
    display: flex;
    margin-left: -8px;
  }
  .lan {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 80px;
    line-height: 80px;
    font-family: SourceHanSansCN-Bold;
    font-size: 15px;
    margin-left: 20px;
    color: #fff;
    text-align: left;
  }
  .changeLan {
    width: 50px;
    height: 100%;
    text-align: center;
    font-weight: normal;
  }
  .lanActive {
    color: #ca9d76;
    font-weight: normal;
  }
  .topCulture {
    position: relative;
    float: right;
    z-index: 100;
    width: 14px;
    height: 14px;
    line-height: 80px;
    margin-left: 25px;
    cursor: pointer;
  }
  .wapCulture {
    position: relative;
    float: right;
    z-index: 100;
    width: 14px;
    height: 14px;
    line-height: 80px;
    margin-left: 25px;
    cursor: pointer;
  }
  .topCulture::after {
    content: "";
    position: absolute;
    left: -12px;
    top: 100%;
    transform: translateY(142%);
    width: 1px;
    height: 15px;
    background-color: #fff;
  }
  .topCulture::before {
    content: "";
    position: absolute;
    right: -12px;
    top: 100%;
    transform: translateY(142%);
    width: 1px;
    height: 15px;
    background-color: #fff;
  }
  .wapCulture::after {
    content: "";
    position: absolute;
    left: -12px;
    top: 100%;
    transform: translateY(142%);
    width: 1px;
    height: 15px;
    background-color: #000;
  }
  .wapCulture::before {
    content: "";
    position: absolute;
    right: -12px;
    top: 100%;
    transform: translateY(142%);
    width: 1px;
    height: 15px;
    background-color: #000;
  }
  .sub-wap-menu-right {
    position: relative;
    top: 0px;
    right: 20px;
    height: 80px;
    width: 18px;
    z-index: 1000;
  }
  .open-menu {
    display: block;
    width: 16px;
    height: 18px;
    position: relative;
    cursor: pointer;
    object-fit: contain;
  }
  .close-menu img {
    width: 16px;
    height: 16px;
  }
  .wap-line-first {
    margin: 80px auto 0;
    width: 90%;
    z-index: 100;
    height: 1px;
    background-color: #585c64;
  }
  .wap-line {
    margin: 0 auto;
    width: 90%;
    height: 1px;
    background-color: #585c64;
  }
  .sub-wap-content {
    margin-top: 0px; /* 确保内容不会覆盖顶部菜单 */
    max-height: calc(100vh - 100px); /* 视口高度减去顶部菜单的高度 */
    overflow-y: auto; /* 允许垂直滚动 */
    -webkit-overflow-scrolling: touch; /* 改善移动设备上的滚动体验 */
  }
  .sub-wap-content-title {
    width: 90%;
    position: relative;
    height: 80px;
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    color: #ffffff;
    text-align: left;
    font-weight: 700;
    line-height: 80px;
    margin: 0 auto;
  }
  .sub-wap-subtitle {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: left;
    font-weight: 500;
    width: 80%;
    margin: 0px 0 5px 60px;
  }
  .sub-wap-subtitle a {
    position: relative;
    display: inline-block;
    text-decoration: none;
    color: #fff;
    height: 30px;
    padding-bottom: 2px;
    overflow: hidden;
    background-image: linear-gradient(
      to right,
      #2c2c2c 100%,
      rgba(255, 255, 255, 0) 0%
    );
    background-position: 0% 100%;
    background-repeat: no-repeat;
    background-size: 0 2px;
    transition: background-size 0.3s;
  }
  .sub-wap-subtitle:last-child {
    margin-bottom: 20px;
  }
  /* 屏幕滚动后的处理 */
  .scroll {
    height: 80px;
    background-color: #fff; /* 替换为你需要的颜色 */
    border-bottom: 1px solid #f2f2f2;
    z-index: 1000;
  }
  .wapSubMenu {
    color: #000;
    background-color: #fff; /* 替换为你需要的颜色 */
  }
  .wapSubMenu a {
    color: #000;
  }
  .redUn {
    color: #ca9d76;
  }

  .lineUn a {
    color: #ca9d76;
    height: 32px;
  }
  .lineUn a::after {
    content: "";
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 2px;
    z-index: 999;
    background-color: #ca9d76;
  }
}
</style>